// Mirrors the ResultEnum values on the server-side FB/IG/LI assessment classes.
// Keep these in sync with:
//   server/src/processor_app/services/evaluation/assessments/entity/entity_facebook_*.py
//   server/src/processor_app/services/evaluation/assessments/entity/entity_instagram_*.py
//   server/src/processor_app/services/evaluation/assessments/entity/entity_linkedin_*.py

const SKIP = { label: "— skip —", value: "" };

export const FACEBOOK_FOLLOWER_OPTIONS = [
  SKIP,
  { label: "Not found", value: "FACEBOOK_NOT_FOUND" },
  { label: "0 followers", value: "FACEBOOK_FOUND_ZERO_FOLLOWERS" },
  { label: "1-10 followers", value: "FACEBOOK_FOUND_ONE_TO_TEN_FOLLOWERS" },
  { label: "10-35 followers", value: "FACEBOOK_FOUND_TEN_TO_THIRTY_FIVE_FOLLOWERS" },
  { label: "35-100 followers", value: "FACEBOOK_FOUND_THIRTY_FIVE_TO_ONE_HUNDRED_FOLLOWERS" },
  { label: "100-250 followers", value: "FACEBOOK_FOUND_ONE_HUNDRED_TO_TWO_FIFTY_FOLLOWERS" },
  { label: "250-500 followers", value: "FACEBOOK_FOUND_TWO_FIFTY_TO_FIVE_HUNDRED_FOLLOWERS" },
  { label: "500+ followers", value: "FACEBOOK_FOUND_FIVE_HUNDRED_PLUS_FOLLOWERS" },
];

export const FACEBOOK_ACCOUNT_AGE_OPTIONS = [
  SKIP,
  { label: "Not found", value: "FACEBOOK_NOT_FOUND" },
  { label: "0-1 month", value: "FACEBOOK_CREATED_ZERO_TO_ONE_MONTH" },
  { label: "1-6 months", value: "FACEBOOK_CREATED_ONE_TO_SIX_MONTHS" },
  { label: "6 months - 1 year", value: "FACEBOOK_CREATED_LESS_THAN_ONE_YEAR" },
  { label: "1-3 years", value: "FACEBOOK_CREATED_ONE_TO_THREE_YEARS" },
  { label: "3+ years", value: "FACEBOOK_CREATED_MORE_THAN_THREE_YEARS" },
];

export const INSTAGRAM_FOLLOWER_OPTIONS = [
  SKIP,
  { label: "Not found", value: "INSTAGRAM_NOT_FOUND" },
  { label: "0 followers", value: "INSTAGRAM_FOUND_ZERO_FOLLOWERS" },
  { label: "1-4 followers", value: "INSTAGRAM_FOUND_ONE_TO_FIVE_FOLLOWERS" },
  { label: "5-19 followers", value: "INSTAGRAM_FOUND_FIVE_TO_TWENTY_FOLLOWERS" },
  { label: "20-99 followers", value: "INSTAGRAM_FOUND_TWENTY_TO_ONE_HUNDRED_FOLLOWERS" },
  { label: "100-499 followers", value: "INSTAGRAM_FOUND_ONE_HUNDRED_TO_FIVE_HUNDRED_FOLLOWERS" },
  { label: "500-999 followers", value: "INSTAGRAM_FOUND_FIVE_HUNDRED_TO_ONE_THOUSAND_FOLLOWERS" },
  { label: "1000+ followers", value: "INSTAGRAM_FOUND_ONE_THOUSAND_PLUS_FOLLOWERS" },
];

export const INSTAGRAM_ACCOUNT_AGE_OPTIONS = [
  SKIP,
  { label: "Not found", value: "INSTAGRAM_NOT_FOUND" },
  { label: "Less than 1 month old", value: "LESS_THAN_ONE_MONTH" },
  { label: "1 month or older", value: "ONE_MONTH_OR_OLDER" },
];

export const LINKEDIN_FOLLOWER_OPTIONS = [
  SKIP,
  { label: "Not found", value: "LINKEDIN_NOT_FOUND" },
  { label: "0 followers", value: "LINKEDIN_FOUND_ZERO_FOLLOWERS" },
  { label: "1-9 followers", value: "LINKEDIN_FOUND_ONE_TO_TEN_FOLLOWERS" },
  { label: "10-49 followers", value: "LINKEDIN_FOUND_TEN_TO_FIFTY_FOLLOWERS" },
  { label: "50-99 followers", value: "LINKEDIN_FOUND_FIFTY_TO_ONE_HUNDRED_FOLLOWERS" },
  { label: "100-499 followers", value: "LINKEDIN_FOUND_ONE_HUNDRED_TO_FIVE_HUNDRED_FOLLOWERS" },
  { label: "500-999 followers", value: "LINKEDIN_FOUND_FIVE_HUNDRED_TO_ONE_THOUSAND_FOLLOWERS" },
  { label: "1000+ followers", value: "LINKEDIN_FOUND_ONE_THOUSAND_PLUS_FOLLOWERS" },
];
